export enum SeasonTypes {
  Season = "SEASON",
  Tournament = "TOURNAMENT",
  OneOff = "ONE_OFF",
  MultiYearHistorical = "MULTI_YEAR_HISTORICAL",
  PreSeason = "PRESEASON",
}
